// (function () {
//   // ---------- 1) 解析 from_size ----------
//   function getParam(name) {
//     return new URLSearchParams(window.location.search).get(name);
//   }
//   function norm(s) {
//     return (s || "")
//       .toLowerCase()
//       .replace(/[’‘]/g, "'")
//       .replace(/\s+/g, "")
//       .trim();
//   }

//   const fromSize = (getParam("from_size") || "").toLowerCase();
//   const map = { "4x8": "4' X 8'", "4x10": "4' X 10'" }; // 这里按你页面真实文案改
//   const targetLabel = map[fromSize];
//   if (!targetLabel) return;
//   const targetN = norm(targetLabel);

//   // ---------- 2) PC：同步选中态 + 顶部文案 + 触发切换 ----------
//   function applyPC() {
//     const options = document.querySelectorAll(".product-pc-content .select-content-list-module.option");
//     if (!options.length) return false;

//     let matched = null;
//     options.forEach(el => {
//       const t = el.querySelector(".pro-val-size")?.textContent || el.textContent || "";
//       if (norm(t).includes(targetN)) matched = el;
//     });
//     if (!matched) return false;

//     // 选中态
//     options.forEach(el => el.classList.remove("selected"));
//     matched.classList.add("selected");

//     // 顶部显示文案同步
//     const showSize = document.querySelector(".product-pc-content .select-content-module .pro-val-size");
//     const showFt = document.querySelector(".product-pc-content .select-content-module .pro-val-square");
//     const newSize = matched.querySelector(".pro-val-size")?.textContent?.trim();
//     const newFt = matched.getAttribute("data-ft-number");

//     if (showSize && newSize) showSize.textContent = newSize;
//     if (showFt && newFt) showFt.innerHTML = `(${newFt} ft<sup>2</sup>)`;

//     // 触发你们现有逻辑（很多主题是监听 click）
//     matched.click();

//     // 收起下拉（可选）
//     const list = document.querySelector(".product-pc-content .select-content-list");
//     if (list) list.style.display = "none";

//     return true;
//   }

//   // ---------- 3) Mobile：点中对应 tab/radio + 同步 selected ----------
//   function applyMobile() {
//     const items = document.querySelectorAll(".product-mobile-Size-Needed-content .option-val-item");
//     if (!items.length) return false;

//     let matched = null;
//     items.forEach(el => {
//       const t = el.textContent || "";
//       if (norm(t).includes(targetN)) matched = el;
//     });
//     if (!matched) return false;

//     // 视觉选中
//     items.forEach(el => el.classList.remove("selected"));
//     matched.classList.add("selected");

//     // 同步 radio checked（你这里用的是 input.mobile_option）
//     const label = matched.closest("label");
//     const radio = label ? label.querySelector("input[type='radio']") : null;
//     if (radio) {
//       radio.checked = true;
//       radio.dispatchEvent(new Event("change", { bubbles: true }));
//     }

//     // 触发原有绑定（有些是监听 click）
//     matched.click();

//     return true;
//   }

//   // ---------- 4) 重试执行（避免 DOM/脚本晚加载） ----------
//   function retry(fn, max = 40, gap = 200) {
//     let tries = 0;
//     const t = setInterval(() => {
//       tries++;
//       const ok = fn();
//       if (ok || tries >= max) clearInterval(t);
//     }, gap);
//   }

//   // DOM ready 后跑（你也可以不等 ready，反正有 retry）
//   retry(applyPC);
//   retry(applyMobile);
// })();


// 不显示4x8 和 4x10 在名字上方
(function () {
  // ---------- 1) 解析 from_size ----------
  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }
  function norm(s) {
    return (s || "")
      .toLowerCase()
      .replace(/[’‘]/g, "'")
      .replace(/\s+/g, "")
      .trim();
  }

  const fromSize = (getParam("from_size") || "").toLowerCase();
  const map = { "4x8": "4' X 8'", "4x10": "4' X 10'" }; // 这里按你页面真实文案改
  const targetLabel = map[fromSize];
  if (!targetLabel) return;
  const targetN = norm(targetLabel);

  // ✅ ---------- 1.5) 隐藏 product-text-link（仅 4x8 / 4x10 入口） ----------
  function hideCollectionLinkIfNeeded() {
    // 你截图里 link 在 a.product-text-link / .product-text-link-div
    document.querySelectorAll(".product-text-link-div, a.product-text-link").forEach(el => {
      el.style.display = "none";
    });
  }
  // 立刻执行一次 + 再补一次（有些模块晚渲染）
  hideCollectionLinkIfNeeded();
  setTimeout(hideCollectionLinkIfNeeded, 300);
  setTimeout(hideCollectionLinkIfNeeded, 1000);

  // ---------- 2) PC：同步选中态 + 顶部文案 + 触发切换 ----------
  function applyPC() {
    const options = document.querySelectorAll(".product-pc-content .select-content-list-module.option");
    if (!options.length) return false;

    let matched = null;
    options.forEach(el => {
      const t = el.querySelector(".pro-val-size")?.textContent || el.textContent || "";
      if (norm(t).includes(targetN)) matched = el;
    });
    if (!matched) return false;

    options.forEach(el => el.classList.remove("selected"));
    matched.classList.add("selected");

    const showSize = document.querySelector(".product-pc-content .select-content-module .pro-val-size");
    const showFt = document.querySelector(".product-pc-content .select-content-module .pro-val-square");
    const newSize = matched.querySelector(".pro-val-size")?.textContent?.trim();
    const newFt = matched.getAttribute("data-ft-number");

    if (showSize && newSize) showSize.textContent = newSize;
    if (showFt && newFt) showFt.innerHTML = `(${newFt} ft<sup>2</sup>)`;

    matched.click();

    const list = document.querySelector(".product-pc-content .select-content-list");
    if (list) list.style.display = "none";

    return true;
  }

  // ---------- 3) Mobile：点中对应 tab/radio + 同步 selected ----------
  function applyMobile() {
    const items = document.querySelectorAll(".product-mobile-Size-Needed-content .option-val-item");
    if (!items.length) return false;

    let matched = null;
    items.forEach(el => {
      const t = el.textContent || "";
      if (norm(t).includes(targetN)) matched = el;
    });
    if (!matched) return false;

    items.forEach(el => el.classList.remove("selected"));
    matched.classList.add("selected");

    const label = matched.closest("label");
    const radio = label ? label.querySelector("input[type='radio']") : null;
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    }

    matched.click();
    return true;
  }

  // ---------- 4) 重试执行（避免 DOM/脚本晚加载） ----------
  function retry(fn, max = 40, gap = 200) {
    let tries = 0;
    const t = setInterval(() => {
      tries++;
      const ok = fn();
      if (ok || tries >= max) clearInterval(t);
    }, gap);
  }

  retry(applyPC);
  retry(applyMobile);
})();